import React, { useState } from 'react';
import RoomVoicePanel from './RoomVoicePanel';
import { useRoomVoice } from '../hooks/useRoomVoice';

export default function RoomVoiceEntry({ roomId, user, roomName, voicePresence }) {
  const [panelOpen, setPanelOpen] = useState(false);
  const voice = useRoomVoice({
    roomId,
    user,
    enabled: Boolean(roomId && user?.id),
  });
  const fallbackParticipants = voicePresence?.participants || [];
  const visibleParticipants = voice.joined ? voice.participants : fallbackParticipants;
  const visibleParticipantCount = voice.joined
    ? voice.participants.length
    : (voicePresence?.count || 0);
  const visibleSpeakingCount = voice.joined
    ? voice.speakingCount
    : (voicePresence?.speakingCount || 0);
  const isLive = voice.joined || visibleParticipantCount > 0;

  return (
    <div className="room-voice-anchor">
      <button
        className={`room-voice-trigger${isLive ? ' is-live' : ''}`}
        onClick={() => setPanelOpen((open) => !open)}
        aria-label="Open room voice panel"
      >
        <span className="room-voice-trigger-dot" />
        Voice
        <span className="room-voice-trigger-count">{visibleParticipantCount}</span>
      </button>

      {panelOpen && (
        <div className="room-voice-popover">
          <RoomVoicePanel
            roomName={roomName}
            joined={voice.joined}
            participants={visibleParticipants}
            selfMuted={voice.selfMuted}
            isMicInitializing={voice.isMicInitializing}
            isSwitchingDevice={voice.isSwitchingDevice}
            connectionState={voice.connectionState}
            statusDetail={voice.statusDetail}
            error={voice.error}
            needsAudioResume={voice.needsAudioResume}
            speakingCount={visibleSpeakingCount}
            noiseSuppressionEnabled={voice.noiseSuppressionEnabled}
            canPublishAudio={voice.canPublishAudio}
            publishRestrictionReason={voice.publishRestrictionReason}
            isRoomOwner={voice.isRoomOwner}
            isVoiceLocked={voice.isVoiceLocked}
            audioInputDevices={voice.audioInputDevices}
            audioOutputDevices={voice.audioOutputDevices}
            selectedAudioInputId={voice.selectedAudioInputId}
            selectedAudioOutputId={voice.selectedAudioOutputId}
            canSelectAudioOutput={voice.canSelectAudioOutput}
            onJoin={voice.joinVoice}
            onLeave={voice.leaveVoice}
            onRefreshDevices={voice.refreshDevices}
            onStartAudio={voice.startAudioPlayback}
            onToggleMute={voice.toggleMute}
            onSelectAudioInput={voice.selectAudioInput}
            onSelectAudioOutput={voice.selectAudioOutput}
            onToggleNoiseSuppression={voice.setNoiseSuppressionEnabled}
          />
        </div>
      )}
    </div>
  );
}
